export const sortBy = (a, b, field, order) => {
  if (order === 'asc') {
    if (field === 'school') {
      return a.school?.name?.localeCompare(b.school?.name);
    }
    if (field === 'grade') {
      return a.grade?.name?.localeCompare(b.grade?.name);
    }
    if (field === 'teacher') {
      return a.teacher?.fullName?.localeCompare(b.teacher?.fullName);
    }
    if (field === 'createdBy') {
      return a.createdBy?.fullName?.localeCompare(b.createdBy?.fullName);
    }
    if (field === 'name') {
      return a.name?.localeCompare(b.name);
    }
    if (field === 'fullName') {
      return a.fullName?.localeCompare(b.fullName);
    }
    if (field === 'schoolName') {
      return a.schoolName?.localeCompare(b.schoolName);
    }
    if (field === 'licenseType') {
      return (a.licenseType || '').localeCompare(b.licenseType || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'teacherName') {
      return a.teacherName?.localeCompare(b.teacherName);
    }
    if (field === 'className') {
      return a.className?.localeCompare(b.className);
    }
    if (field === 'username') {
      return a.username?.localeCompare(b.username);
    }
    if (field === 'teachers') {
      return (a.teacherCount || 0) - (b.teacherCount || 0);
    }
    if (field === 'classes') {
      const aVal = a.classCount === 'N/A' ? -1 : (a.classCount || 0);
      const bVal = b.classCount === 'N/A' ? -1 : (b.classCount || 0);
      return aVal - bVal;
    }
    if (field === 'students') {
      const aVal = a.studentCount === 'N/A' ? -1 : (a.studentCount || 0);
      const bVal = b.studentCount === 'N/A' ? -1 : (b.studentCount || 0);
      return aVal - bVal;
    }
    if (field === 'classCount') {
      const aVal = a.classCount === 'N/A' ? -1 : (a.classCount || 0);
      const bVal = b.classCount === 'N/A' ? -1 : (b.classCount || 0);
      return aVal - bVal;
    }
    if (field === 'studentCount') {
      const aVal = a.studentCount === 'N/A' ? -1 : (a.studentCount || 0);
      const bVal = b.studentCount === 'N/A' ? -1 : (b.studentCount || 0);
      return aVal - bVal;
    }
    if (field === 'city') {
      return (a.city || '').localeCompare(b.city || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'state') {
      return (a.state || '').localeCompare(b.state || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'country') {
      return (a.country || '').localeCompare(b.country || '', undefined, { sensitivity: 'base' });
    }
    return a[field] > b[field] ? 1 : -1;
  } else {
    if (field === 'school') {
      return b.school?.name?.localeCompare(a.school?.name);
    }
    if (field === 'grade') {
      return b.grade?.name?.localeCompare(a.grade?.name);
    }
    if (field === 'teacher') {
      return b.teacher?.fullName?.localeCompare(a.teacher?.fullName);
    }
    if (field === 'createdBy') {
      return b.createdBy?.fullName?.localeCompare(a.createdBy?.fullName);
    }
    if (field === 'name') {
      return b.name?.localeCompare(a.name);
    }
    if (field === 'fullName') {
      return b.fullName?.localeCompare(a.fullName);
    }
    if (field === 'schoolName') {
      return b.schoolName?.localeCompare(a.schoolName);
    }
    if (field === 'licenseType') {
      return (b.licenseType || '').localeCompare(a.licenseType || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'className') {
      return b.className?.localeCompare(a.className);
    }
    if (field === 'teacherName') {
      return b.teacherName?.localeCompare(a.teacherName);
    }
    if (field === 'username') {
      return b.username?.localeCompare(a.username);
    }
    if (field === 'teachers') {
      return (b.teacherCount || 0) - (a.teacherCount || 0);
    }
    if (field === 'classes') {
      const aVal = a.classCount === 'N/A' ? -1 : (a.classCount || 0);
      const bVal = b.classCount === 'N/A' ? -1 : (b.classCount || 0);
      return bVal - aVal;
    }
    if (field === 'students') {
      const aVal = a.studentCount === 'N/A' ? -1 : (a.studentCount || 0);
      const bVal = b.studentCount === 'N/A' ? -1 : (b.studentCount || 0);
      return bVal - aVal;
    }
    if (field === 'classCount') {
      const aVal = a.classCount === 'N/A' ? -1 : (a.classCount || 0);
      const bVal = b.classCount === 'N/A' ? -1 : (b.classCount || 0);
      return bVal - aVal;
    }
    if (field === 'studentCount') {
      const aVal = a.studentCount === 'N/A' ? -1 : (a.studentCount || 0);
      const bVal = b.studentCount === 'N/A' ? -1 : (b.studentCount || 0);
      return bVal - aVal;
    }
    if (field === 'city') {
      return (b.city || '').localeCompare(a.city || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'state') {
      return (b.state || '').localeCompare(a.state || '', undefined, { sensitivity: 'base' });
    }
    if (field === 'country') {
      return (b.country || '').localeCompare(a.country || '', undefined, { sensitivity: 'base' });
    }
    return a[field] < b[field] ? 1 : -1;
  }
};
